import { gql } from 'apollo-angular'

import { ORGANIZATION_FIELDS } from '../../fragments/organization.fragment'
import { USER_FIELDS } from '../../fragments/user.fragment'

export const GET_USER_ME = gql`
  {
    meUser {
      user {
        ...UserFields
        organization {
          ...OrganizationFields
          billingAdmins(limit: -1) {
            docs {
              id
              first_name
              last_name
              name
              email
            }
          }
        }
      }
    }
  }
  ${USER_FIELDS}
  ${ORGANIZATION_FIELDS}
`
